// extracted by mini-css-extract-plugin
module.exports = {"container":"imgCarousel_container__2l_JF","image":"imgCarousel_image__kXgkK","btnGroup":"imgCarousel_btnGroup__1NFX0"};